import PptxGenJS from "pptxgenjs";
import { TemplateData } from "../index";
import { TEXT_OPTIONS } from "../masters/components";

export const addPsychInstructionsSlide = (
  pres: PptxGenJS,
  data: TemplateData
) => {
  const slide = pres.addSlide({ masterName: "SPLIT_RIGHT_MASTER" });

  slide.addText("Approach and use of this report", { placeholder: "title" });

  slide.addText(
    [
      {
        text: "Approach",
        options: TEXT_OPTIONS.caption,
      },
      {
        text: "This report provides a synthesized understanding of the executive’s characteristics based solely on the executive’s responses to the:",
        options: {
          ...TEXT_OPTIONS.body,
          paraSpaceAfter: 4,
        },
      },
      {
        text: "Leadership Span™ solution powered by Hogan Assessments​",
        options: TEXT_OPTIONS.bullet,
      },
      {
        text: "Occupational Personality Questionnaire (OPQ32r)​",
        options: TEXT_OPTIONS.bullet,
      },
      {
        text: "An in-depth interview with an industry expert and a leadership assessment expert",
        options: TEXT_OPTIONS.bullet,
      },
      {
        text: "Use",
        options: {
          ...TEXT_OPTIONS.caption,
          paraSpaceBefore: 24,
        },
      },
      {
        text: "This document has been prepared specifically by Russell Reynolds Associates for a client assessment and should not be used for any reason other than that for which it was originally produced.",
        options: {
          ...TEXT_OPTIONS.body,
          paraSpaceAfter: 4,
        },
      },

      {
        text: "The findings are intended to be used in conjunction with other sources of information about the Executive.",
        options: {
          ...TEXT_OPTIONS.body,
          paraSpaceAfter: 4,
        },
      },
      {
        text: "We recommend this report not be used after a period of two years because people develop and acquire new skills over time.",
        options: {
          ...TEXT_OPTIONS.body,
          paraSpaceAfter: 4,
        },
      },
      {
        text: "This document should only be made available to individuals who have received guidance in the interpretation and use of this report and are directly involved in the deployment or development of this individual.",
        options: {
          ...TEXT_OPTIONS.body,
          paraSpaceAfter: 4,
        },
      },
    ],
    {
      x: 0.46,
      y: 1.44,
      w: 6.65,
      h: 6,
      valign: "middle",
    }
  );

  slide.addText(
    [
      {
        text: "Disclaimer",
        options: {
          ...TEXT_OPTIONS.caption,
          paraSpaceBefore: 24,
        },
      },
      {
        text: "Russell Reynolds Associates does not evaluate executives on the basis of age, race, sex, national origin, religion, disability or other protected characteristics. ​",
        options: TEXT_OPTIONS.body,
      },
    ],
    {
      x: 8.99,
      y: 1.44,
      w: 6.65,
      h: 6,
      valign: "middle",
    }
  );
};
